import { Paper } from '@mui/material';
import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import ErrorMessage from '../../../Elements/ErrorMessage';
import ImportShopSearchParams from './ImportShopSearchParams';
import ImportShopService from '../../../Services/ImportShopService';
import ImportShopItem from '../../../Domain/ImportShopItem';
import GeneralSearchStrip from '../../../Elements/GeneralSearchStrip';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import SftpDatumItem from '../../../Domain/SftpDatumItem';
import SftpDatumService from '../../../Services/SftpDatumService';
import SftpAdminSearchParams from '../Sftp/SftpAdminSearchParams';
import SurveyDatumService from '../../../Services/SurveyDatumService';
import SurveySearchParams from '../Survey/SurveySearchParams';
import SurveyDatumItem from '../../../Domain/SurveyDatumItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import SftpWindowDescription from '../Sftp/SftpWindowDescription';
import SurveyWindowDescription from '../Survey/SurveyWindowDescription';
import TabbedPage from '../../../Elements/TabbedPage';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';

class ImportShopAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      itemList: [],
      loading: true,
      selected: -1,
      selectedAddress: null,
      orderBy: 'Id',
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      shownPanel: ImportShopSearchParams.isThereAnySearchParameter() ? ShownPanelsEnum.Search : ShownPanelsEnum.None,
      searchItem: new ImportShopSearchParams(),
      // selectedTab:0,
    };
    this.showPanel = this.showPanel.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);
    SftpDatumItem.editFunction = this.clickOnSftpEditIcon.bind(this);
    SurveyDatumItem.editFunction = this.clickOnSurveyEditIcon.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  clickOnSftpEditIcon(selectedItem, item) {
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  clickOnSurveyEditIcon(selectedItem, item) {
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.EditMainItem,
    });
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({
        shownPanel: ShownPanelsEnum.None,
        selected: -1,
        selectedAddress: null,
      });
    }
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.refresh();
      panelId = ShownPanelsEnum.None;
    } else if (panelId === ShownPanelsEnum.Import) {
      ImportShopService.StartImportManually()
        .then((result) => ErrorMessage.SetInfo(result.data))
        .catch(() => ErrorMessage.SetErrorMessage('ISA216'));
      panelId = ShownPanelsEnum.None;
    } else if (panelId === ShownPanelsEnum.GetIP) {
      ImportShopService.GetPublicIp()
        .then((result) => ErrorMessage.SetInfo(result.data))
        .catch(() => ErrorMessage.SetErrorMessage('ISA226'));
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  editPanelOnClose(refresh) {
    let tab = this.state.selectedTab;
    if (this.state.shownPanel === ShownPanelsEnum.AddNewItem) tab = 1;
    if (this.state.shownPanel === ShownPanelsEnum.AddNewSubItem) tab = 2;
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    if (refresh) {
      this.setState({ selectedTab: -1 }, () => this.setState({ selectedTab: tab }));
    }
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.Search,
          <GeneralSearchStrip
            searchItem={this.state.searchItem}
            searchparamsType={ImportShopSearchParams}
            isRefreshDisabled={false}
            isFilterDisabled={false}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnOk={(shownPanel, searchItem) => {
              this.setState({
                searchItem,
                selectedTab: 0,
              });
            }}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={SftpWindowDescription}
            errorCode='ISA145'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditMainItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={SurveyWindowDescription}
            errorCode='ISA154'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new SftpDatumItem()}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={SftpWindowDescription}
            errorCode='ISA162'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewSubItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new SurveyDatumItem()}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={SurveyWindowDescription}
            errorCode='ISA170'
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          colors={[ButtonColorsEnum.Secondary, ButtonColorsEnum.Primary]}
          tooltips={['Create SFTP', 'Create Survey']}
          keys={[ShownPanelsEnum.AddNewItem, ShownPanelsEnum.AddNewSubItem]}
          icons={['fa-solid fa-server', 'fa-solid fa-poll-h']}
          roles={['User', 'User']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  ClickOnStartImportManuallyButton() {
    ImportShopService.StartImportManually()
      .then((result) => ErrorMessage.SetInfo(result.data))
      .catch(() => ErrorMessage.SetErrorMessage('ISA216'));
  }

  ClickOnGetPublicIpButton() {
    ImportShopService.GetPublicIp()
      .then((result) => ErrorMessage.SetInfo(result.data))
      .catch(() => ErrorMessage.SetErrorMessage('ISA226'));
  }

  renderActionButtonRow() {
    return (
      <ButtonRow
        labels={['Start Import Manually', 'Get Public IP of the App']}
        keys={[ShownPanelsEnum.Import, ShownPanelsEnum.GetIP]}
        roles={['JustForAdmins']}
        onClick={this.showPanel}
        className={'container-fluid'}
        buttonTypes={[ButtonTypeEnum.LargeNormal, ButtonTypeEnum.LargeNormal]}
      />
    );
  }

  renderSearchStrip() {
    return (
      <GeneralSearchStrip
        searchItem={this.state.searchItem}
        searchparamsType={ImportShopSearchParams}
        isRefreshDisabled={false}
        isFilterDisabled={false}
        clickOnRefresh={this.refresh.bind(this)}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnOk={(shownPanel, searchItem) => {
          this.setState({
            loading: true,
            searchItem: searchItem,
          });
        }}
      />
    );
  }

  render() {
    const tabs = [
      {
        label: 'ImportShops',
        id: 'importshops',
        icon: 'fa-solid fa-shipping-fast',
        component: (
          <TabOfDataTable
            type={ImportShopItem}
            shownPanel={this.state.shownPanel}
            serviceFunction={ImportShopService.GetListBySearching}
            convertDBItemsFunction={ImportShopService.ConvertDBItems}
            searchItem={this.state.searchItem}
            orderDirection={OrderDirectionsEnum.Desc}
            showSearchStrip={true}
            searchParamsType={ImportShopSearchParams}
            clickOnStartSearch={(searchItem) => {
              this.setState({ searchItem: searchItem });
            }}
            errorCode='ISA230'
          />
        ),
      },
      {
        label: 'Sftp Servers',
        id: 'sftpservers',
        icon: 'fa-solid fa-server',
        component: (
          <TabOfDataTable
            type={SftpDatumItem}
            shownPanel={this.state.shownPanel}
            serviceFunction={SftpDatumService.GetListBySearching}
            convertDBItemsFunction={SftpDatumService.ConvertDBItems}
            searchItem={new SftpAdminSearchParams()}
            errorCode='ISA245'
          />
        ),
      },
      {
        label: 'Surveys',
        id: 'surveys',
        icon: 'fa-solid fa-poll-h',
        component: (
          <TabOfDataTable
            type={SurveyDatumItem}
            shownPanel={this.state.shownPanel}
            serviceFunction={SurveyDatumService.GetListBySearching}
            convertDBItemsFunction={SurveyDatumService.ConvertDBItems}
            searchItem={new SurveySearchParams()}
            errorCode='ISA260'
          />
        ),
      },
    ];
    return (
      <div className='contentwrapper'>
        {this.renderSearchStrip()}
        {this.renderButtonsAndPanels()}
        <Paper
          elevation={6}
          className='border p-1 m-1'
        >
          {this.renderActionButtonRow()}
          <TabbedPage tabs={tabs} />
        </Paper>
      </div>
    );
  }
}

export default ImportShopAdmin;
